var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogomark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 82,
    viewBox: "0 0 72 82",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.093 55.4H18.545V81H1V39.857h17.359L1.016 16.885H1V1h36.457C47.56 1 55.306 3.705 60.7 9.114c4.46 4.474 6.737 10.408 6.832 17.802l.003.713c0 6.476-1.576 11.752-4.728 15.828-3.067 3.966-8.562 7.422-13.544 9.36l-.414.158 1.427 1.898L70 81H49.42L30.093 55.4zm16.243-18.356l.228-.196c2.252-1.984 3.415-4.609 3.49-7.873l.004-.34v-.228c0-3.802-1.222-6.654-3.666-8.555-2.359-1.835-5.608-2.785-9.747-2.848L36.198 17H21.74l17.34 22.8c3.008-.32 5.427-1.239 7.256-2.756z",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 2,
    fill: "none"
  })));
}

export default SvgLogomark;